import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { BookmarkIcon } from '../chat/SidebarIcons';

const SavedMessagesHeader = ({
  searchQuery,
  onSearchChange,
  totalCount,
  filteredCount,
  channelSuggestions = [],
  onSuggestionSelect,
}) => {
  const navigate = useNavigate();

  const showSuggestions = useMemo(
    () => searchQuery.trim().length > 0 && channelSuggestions.length > 0,
    [searchQuery, channelSuggestions]
  );

  const handleBack = () => {
    navigate('/chat');
  };

  return (
    <div className="px-4 py-3 border-b border-gray-200 dark:border-gray-700">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-3">
          <button
            onClick={handleBack}
            className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white transition-colors"
            title="Back to chat"
            type="button"
          >
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M10 19l-7-7m0 0l7-7m-7 7h18"
              />
            </svg>
          </button>
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white inline-flex items-center gap-2">
            <BookmarkIcon className="w-5 h-5 text-primary-500" />
            Bookmarks
          </h2>
        </div>
        <div className="text-sm text-gray-500 dark:text-gray-400">
          {filteredCount ?? totalCount}{' '}
          {(filteredCount ?? totalCount) === 1 ? 'bookmark' : 'bookmarks'}
        </div>
      </div>

      <div className="relative">
        <input
          type="text"
          placeholder="Search by channel or message..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          className="w-full px-4 py-2 pl-10 bg-gray-100 dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-primary-500 dark:focus:ring-primary-400"
        />
        <svg
          className="absolute left-3 top-2.5 w-5 h-5 text-gray-400 dark:text-gray-500"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
          />
        </svg>

        {showSuggestions && (
          <div className="absolute left-0 right-0 top-full mt-1 z-20 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-lg overflow-hidden">
            {channelSuggestions.map((suggestion) => (
              <button
                key={suggestion.channelId}
                type="button"
                onClick={() => onSuggestionSelect(suggestion)}
                className="w-full text-left px-4 py-2.5 hover:bg-gray-50 dark:hover:bg-gray-700 text-sm text-gray-800 dark:text-gray-200 flex items-center gap-2"
              >
                <span className="text-gray-400">#</span>
                <span>{suggestion.name}</span>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default SavedMessagesHeader;
